/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".table-wrapper-scroll-y[_ngcontent-%COMP%] {\n  display: block;\n  max-height: 31em;\n  overflow-y: auto;\n  -ms-overflow-style: -ms-autohiding-scrollbar; }"];
export { styles as styles };
